import '.ap{flex-shrink:0;}.ssr-plugin'
import '.au{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.at{height:100%;}.ssr-plugin'
import '.c4{border:none;}.ssr-plugin'
import '.cp{background-color:transparent;}.ssr-plugin'
import '.cq{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.bf{position:sticky;}.ssr-plugin'
import '.cr{top:4rem;}.ssr-plugin'
import '.cs{z-index:7;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.ct{padding-bottom:1rem;}.ssr-plugin'
import '.cu{margin-bottom:1rem;}.ssr-plugin'
import '.cv{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.f{position:fixed;}.ssr-plugin'
import '.bg{top:0px;}.ssr-plugin'
import '.bp{left:0px;}.ssr-plugin'
import '.bq{right:0px;}.ssr-plugin'
import '.br{bottom:0px;}.ssr-plugin'
import '.cw{z-index:9999;}.ssr-plugin'
import '.cx{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.be{justify-content:flex-end;}.ssr-plugin'
import '.av{flex:1;}.ssr-plugin'
import '.c0{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ap au n at c4 cp cq"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b r"
    >
      <div className="bf cr cs v ct cu cv a"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="f bg bp bq br cw v cx a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="au a be cv"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="av c0">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
